import gql from 'graphql-tag';

const updateSubscriptionMutation = gql`
  mutation modifySubscriber($input: ModifySubscriberInput!) {
    modifySubscriber(input: $input) {
      success
      errors
    }
  }
`;

export default updateSubscriptionMutation;
